/* Focus quiz -> Klaviyo (Sam, 16 Oct). Defines window.MDS_KLAVIYO_SEND, which assets/mds-quiz.js calls on the email step's
   submit with buildKlaviyoPayload(email) = { email, consent, event, profile_properties, event_properties }. Before this file
   existed nothing defined it, so every quiz email was dropped.

   Two calls to Klaviyo's public client API (the site's public key, no secret; CORS-safe from the storefront):
   1. client/subscriptions: subscribe the email to email marketing on the quiz list (sections/mds-focus-quiz settings, default
      "MDS // Focus Quiz"), custom_source "Focus Quiz", so the signup source is the quiz. The email step's consent line
      ("We'll also send the odd tip and sale. Unsubscribe anytime.") is the opt-in.
   2. client/events: a "Completed Focus Quiz" event carrying the scores and answers, whose profile block writes the
      segmentation properties onto the profile (mds_source "quiz", mds_type, mds_problem, mds_setup_size, mds_recommended,
      plus mds_vibe, mds_market and mds_quiz_completed_at). The properties ride on the event, not the subscription, so an
      attribute the subscription endpoint refused could never cost the signup itself.
   Config: window.MDS_KLAVIYO_CFG = { companyId, listId, source } from the section. Fails quietly (console.warn): the quiz
   never waits on Klaviyo. */
(function (root) {
  'use strict';
  var CFG = root.MDS_KLAVIYO_CFG || {};
  if (!CFG.companyId || !root.fetch) return;
  var REVISION = '2025-07-15';

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(CFG.companyId), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (r.ok) return r;
      return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 300)); });
    });
  }

  root.MDS_KLAVIYO_SEND = function (p) {
    if (!p || !p.email) return Promise.resolve();
    var ev = p.event_properties || {};
    var props = Object.assign({}, p.profile_properties || {}, {
      mds_vibe: ev.mds_vibe || '',
      mds_market: ev.mds_market || '',
      mds_quiz_completed_at: new Date().toISOString(),
    });
    var jobs = [];
    if (CFG.listId && p.consent === 'email') {
      jobs.push(post('subscriptions/', { data: { type: 'subscription', attributes: {
        custom_source: CFG.source || 'Focus Quiz',
        profile: { data: { type: 'profile', attributes: { email: p.email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
      }, relationships: { list: { data: { type: 'list', id: CFG.listId } } } } }));
    }
    jobs.push(post('events/', { data: { type: 'event', attributes: {
      properties: ev,
      metric: { data: { type: 'metric', attributes: { name: p.event || 'Completed Focus Quiz' } } },
      profile: { data: { type: 'profile', attributes: { email: p.email, properties: props } } },
    } } }));
    return Promise.all(jobs.map(function (j) { return j.then(function () { return null; }, function (e) { return e; }); }))
      .then(function (errs) { errs.forEach(function (e) { if (e) console.warn('[MDS quiz] Klaviyo', e.message); }); });
  };
})(window);
